import { useContext } from 'react'

import { AccountStoreContext } from '../../contexts'
import AccountStore from '../../store/AccountStore'

const useAccountStore = (): AccountStore => {
   const accountStore = useContext(AccountStoreContext)
   if (!accountStore) {
      throw new Error('Expected to be wrapped in Account Store Provider')
   }
   return accountStore
}

export { useAccountStore }
